// @ts-check
import React, { lazy, Suspense } from "react";
import "./Externo.scss";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getStudyByToken } from "../../api/studies";
import SplashScreen from "../../pages/splachscreen/page";
import Caducado from "./Caducado";
import Study from "../../models/studies/study";

const Visor = lazy(() => import("../NuevoVisor/Visor"));

function Externo() {
  const { token } = useParams();
  const [Listo, setListo] = useState(
    /** @type {{listo: boolean, acceso: boolean, estudio: Study | null}} */ ({
      listo: false,
      acceso: false,
      estudio: null,
    }),
  );
  let contenido;
  useEffect(() => {
    if (!token) return;
    getStudyByToken(token)
      .then((res) => {
        setListo({ listo: true, acceso: true, estudio: res });
      })
      .catch((err) => {
        console.log(err);
        setListo({ listo: true, acceso: false, estudio: null });
      });
    return () => {
      console.log("cerando");
    };
  }, []);
  if (Listo.listo) {
    if (Listo.acceso && Listo.estudio) {
      contenido = (
        <Suspense fallback={<div>Cargando...</div>}>
          <Visor estudio={Listo.estudio} />
        </Suspense>
      );
    } else {
      contenido = <Caducado />;
    }
  } else {
    contenido = <SplashScreen message="Cargando Componentes" />;
  }
  return <div id="Externo">{contenido}</div>;
}
export default Externo;
